import React from 'react';

/**
 * Sparkline — minimal SVG line / area for KPI cards.
 * Pure presentational: pass `points` (array of numbers); we'll auto-scale.
 * Strictly two colors (ink + gold) — no gradients, no neon.
 */
export function Sparkline({
  points = [],
  width = 80,
  height = 36,
  stroke = '#C9A568',
  showDot = true,
  className = '',
}) {
  if (!Array.isArray(points) || points.length < 2) {
    return <svg width={width} height={height} className={className} aria-hidden="true" />;
  }
  const min = Math.min(...points);
  const max = Math.max(...points);
  const span = max - min || 1;
  const stepX = width / (points.length - 1);
  const path = points
    .map((v, i) => {
      const x = i * stepX;
      const y = height - ((v - min) / span) * (height - 4) - 2;
      return `${i === 0 ? 'M' : 'L'} ${x.toFixed(1)} ${y.toFixed(1)}`;
    })
    .join(' ');
  const lastX = (points.length - 1) * stepX;
  const lastY = height - ((points[points.length - 1] - min) / span) * (height - 4) - 2;
  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      className={`spark-draw ${className}`}
      aria-hidden="true"
    >
      <path d={path} fill="none" stroke={stroke} strokeWidth="1.6" strokeLinecap="round" />
      {showDot && <circle cx={lastX} cy={lastY} r="2" fill={stroke} />}
    </svg>
  );
}
export default Sparkline;
